
import Airpod from "../../../assets/duotone/Airpod.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AirpodIcon({ className, dataTestid = "AirpodIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Airpod data-testid={dataTestid} className={classes} {...rest} />
  );
}
